import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type StoreButtonProps = {
  icon: IconProp;
  smallText: string;
  bigText: string;
  href: string;
};

export default function ServiceLink({
  icon,
  smallText,
  bigText,
  href,
}: StoreButtonProps) {
  return (
    <Link
      href={href}
      className="group flex justify-center items-center bg-[#0b0b0d] rounded-full transition-all duration-300 hover:bg-[#191818] hover:shadow-lg space-x-2 px-8 py-3 md:py-5"
      target="_blank"
    >
      <FontAwesomeIcon
        icon={icon}
        className="text-xl md:text-3xl xl:text-4xl flex-shrink-0 transition-colors duration-300 group-hover:text-white text-white w-10"
      />
      <div className="flex flex-col w-auto md:w-full transition-colors duration-300 group-hover:text-white text-light-20 text-left mr-2">
        <span
          className="text-sm md:text-base tracking-tighter leading-4 md:leading-6"
          style={{ fontFamily: '"pre-Regular", sans-serif' }}
        >
          {smallText}
        </span>
        <p
          className="text-lg  md:text-2xl tracking-tight leading-5 md:leading-8 mt-1"
          style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
        >
          {bigText}
        </p>
      </div>
    </Link>
  );
}
